<table
  class="details-table"
  *ngIf="employment$ | async as employment">
  <tr
    *ngIf="transferCounts$ | async as transferCounts; else transferredToMe"
    class="transfers-row">
    <td class="detail-label">{{ ("transfers" | i18n) || "Transfers" }}</td>
    <td class="transfers-info-list">
      <div
        class="transfer-info"
        matTooltipPosition="above"
        [matTooltip]="
          ('transfersTooltip' | i18n) ||
          'Transferiert / Total mögliche Transfers'
        ">
        <mat-icon
          class="transfer-info-icon pending-transfers-icon"
          svgIcon="board-mission-transfer-waiting-clock"></mat-icon>
        <div
          class="transfer-count"
          data-cy="job-transfer-info-count">
          {{ transferCounts.transferred
          }}<span class="transfer-info-slash">/</span>{{ transferCounts.total }}
        </div>
      </div>
      <div
        class="transfer-info"
        matTooltipPosition="above"
        [matTooltip]="
          ('declinedTransfersTooltip' | i18n) || 'abgelehnte Transfers'
        ">
        <mat-icon
          class="transfer-info-icon declined-transfers-icon"
          svgIcon="board-mission-transfer-decline-rejected"></mat-icon>
        {{ transferCounts.declined }}
      </div>
      <div class="transfer-info">
        <div
          class="tooltip-sub-wrapper"
          matTooltipPosition="above"
          [matTooltip]="
            ('activeAutoTransfersTooltip' | i18n) ||
            'aktive automatische Transfers'
          ">
          <mat-icon
            class="transfer-info-icon auto-transfers-icon"
            svgIcon="board-mission-transfer-auto-star"></mat-icon>
          {{ transferCounts.auto }}
        </div>
        <ng-container *ngIf="transferCounts.nextAutoTransfer"
          ><span class="transfer-info-slash">/</span
          >{{
            "nextTransferAt"
              | i18n
                : {
                    date: transferCounts.nextAutoTransfer | date: "dd.MM.yyyy"
                  }
          }}
          ({{ transferCounts.nextAutoTransfer | formatDistance }})</ng-container
        >
      </div>
    </td>
  </tr>
  <ng-template #transferredToMe>
    <tr
      *ngIf="transferredToMeText$ | async as transferredToMeText"
      class="transfers-row"
      [attr.data-cy]="'job-transfer-info-transferred'">
      <td class="detail-label">{{ ("transfers" | i18n) || "Transfers" }}</td>
      <td>
        <div class="transfer-info">{{ transferredToMeText }}</div>
      </td>
    </tr>
  </ng-template>
  <tr *ngIf="employment.department.costCenter">
    <td class="detail-label">{{ ("costCenter" | i18n) || "Kostenstelle" }}</td>
    <td>
      {{ employment.department.costCenter }}
    </td>
  </tr>
  <tr>
    <td class="detail-label">{{ ("workload" | i18n) || "Pensum" }}</td>
    <td>{{ employment.workload }}%</td>
  </tr>
  <tr *ngIf="employment.organisation.address">
    <td class="detail-label">{{ ("details" | i18n) || "Details" }}</td>
    <td>
      {{ employment.organisation.address?.street }},
      {{ employment.organisation.address?.zip }}
      {{ employment.organisation.address?.location }}
    </td>
  </tr>

  <tr *ngIf="employment.description">
    <td class="detail-label">{{ ("description" | i18n) || "Beschreibung" }}</td>
    <td>{{ employment.description }}</td>
  </tr>
  <tr *ngIf="employmentCertificates$ | async as certificatesString">
    <td class="detail-label">
      {{ ("certificates" | i18n) || "Qualifikation" | titlecase }}
    </td>
    <td>{{ certificatesString }}</td>
  </tr>
  <ng-container *ngIf="isDispo$ | async">
    <tr>
      <td class="detail-label">
        {{ ("created" | i18n) || "Erstellt" }}
      </td>
      <td>
        {{ employment.createdAt | displayDate: "dd.MM.yyyy HH:mm" }} /
        {{ employment.createdBy.firstName }}
        {{ employment.createdBy.lastName }},
        {{ employment.customer.displayName }}
      </td>
    </tr>
    <tr>
      <td class="detail-label">
        {{ ("updated" | i18n) || "Geändert" }}
      </td>
      <td>
        {{ employment.updatedAt | displayDate: "dd.MM.yyyy HH:mm" }} /
        {{ employment.lastUpdatedBy.firstName }}
        {{ employment.lastUpdatedBy.lastName }},
        {{ employment.lastUpdatedBy.customerName }}
      </td>
    </tr>
  </ng-container>
</table>
